import { formatDistance } from 'date-fns';
import { cs, de, enUS, es, fr, it, pt } from 'date-fns/locale';

import { UserProfile } from '../../types/user';

export enum NotificationStatus {
	Unread = 'unread',
	Seen = 'seen',
	Read = 'read',
}

export enum NotificationType {
	NewBonus = 'new_bonus',
	BonusAddOn = 'bonus_add_on',
	BonusCommentForReceiver = 'bonus_comment_for_receiver',
	NewMonth = 'new_month',
	EndOfMonth = 'end_of_month',
	BillingPlanChange = 'billing_plan_change',
	BonusCommentForOtherCommenter = 'bonus_comment_for_other_commenter',
	BonusCommentForGiver = 'bonus_comment_for_giver',
	BonusCommentForCC = 'bonus_comment_for_cc',
	NewBonusForCC = 'new_bonus_for_cc',
	WarmUpNonGiver = 'warm_up_non_giver',
	ConstructiveFeedbackRequest = 'constructive_feedback_request',
	ConstructiveFeedbackResponse = 'constructive_feedback_response',
	ConstructiveFeedbackMessage = 'constructive_feedback_message',
	ConstructiveFeedbackResent = 'constructive_feedback_resent',
	ConstructiveFeedbackReportReceived = 'constructive_feedback_report_received',
	ConstructiveFeedbackRequestExpiring = 'constructive_feedback_request_expiring',
	ConstructiveFeedbackUnrequestedFeedback = 'constructive_feedback_unrequested_feedback',
	ConstructiveFeedbackUnrequestedFeedbackReceiverAddedMessage = 'constructive_feedback_unrequested_feedback_receiver_added_message',
	ConstructiveFeedbackUnrequestedFeedbackGiverAddedMessage = 'constructive_feedback_unrequested_feedback_giver_added_message',
	OneOnOneNewMeeting = 'one_on_one_new_meeting',
	Announcement = 'announcement',
	OneOnOneMeetingUpcomingDirectReport = 'one_on_one_meeting_upcoming_direct_report',
	OneOnOneMeetingUpcomingManager = 'one_on_one_meeting_upcoming_manager',
	NominationsEndDate = 'nominations_end_date',
	NominationsStartDate = 'nominations_start_date',
	AdminCheckInSummary = 'admin_check_in_summary',
	ReviewRecordReady = 'review_record_ready',
	ReviewGeneratedByManager = 'review_generated_by_manager',
	ReviewTemplatePublished = 'review_template_published',
	UpcomingReviewDate = 'upcoming_review_date',
	EmployeeSpotlightRead = 'spotlight_ready',
}
export class Notification {
	public avatar?: Pick<UserProfile, 'profile_pic_url' | 'display_name'>;
	public readonly time_ago: string;
	constructor(
		public id: string,
		public status: NotificationStatus,
		public type: NotificationType,
		public message: string,
		public createdDate: Date,
		public action: string | null,
		public content?: Record<string, any>,
		private locale: string = 'en'
	) {
		this.time_ago = formatDistance(createdDate, Date.now(), {
			locale: getLocale(locale),
			includeSeconds: false,
			addSuffix: true,
		});

		if (!!content && !!content['display_name']) {
			this.avatar = content as Pick<UserProfile, 'profile_pic_url' | 'display_name'>;
		}
	}
}

const getLocale = (locale: string) => {
	switch (locale) {
		case 'cs':
			return cs;
		case 'de':
			return de;
		case 'es':
			return es;
		case 'fr':
			return fr;
		case 'it':
			return it;
		case 'pt':
			return pt;
		default:
			return enUS;
	}
};
